class SelectPageUrlDirective {
    constructor() {
        this.restrict = 'A';
    }

    link(scope, element, attrs, controllers) {

        const onChange = () => {
            window.location.href = element.val();
        }

        element.on('change', onChange);

        scope.$on('$destroy', () => {
            element.off('change', onChange);
        });
    }

    static directiveFactory() {
        'ngInject';
        return new SelectPageUrlDirective();
    }
}

export default SelectPageUrlDirective;